import * as config from '../config/base.js';
import * as sentryConfig from '../config/sentry';

export default {
    ...config,
    ...sentryConfig,
};
